// @ts-nocheck
import { createPipe, pipeBufferDebounce, pipeDistribute, softFail } from '@duda-co/fp';
import { getInt } from '../common-props';
import { pipeAddContext, pipeAddVersionContext, pipeBlockLocalhost, pipeDispatchLogEventToConsole, pipeDispatchLogEventToSink, pipeDispatchSentryLogEvent, pipeFilterByLogLevel, pipeFilterSkipJournal, pipeFormatAsTextLine, pipeFormatBatchForSink, pipeFormatMessage } from './log-event-pipeline';
const SECOND = 1000;
const DEFAULT_SINK_DEBOUNCE_TIME = 0.5 * SECOND;
const DEFAULT_SINK_MAX_BUFFER_SIZE = 5;
const PROP_KEY_SINK_DEBOUNCE_TIME = 'common.log.debounceDelay';
const PROP_KEY_SINK_MAX_BUFFER_SIZE = 'common.log.batchLogLimit';
export const LogLevel = {
  TRACE: 'trace',
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error'
};
export const logStream = softFail(createPipe([pipeFormatMessage, pipeAddContext, pipeAddVersionContext, pipeDistribute([
//Send to console
createPipe([pipeFilterByLogLevel(LogLevel.TRACE), pipeFormatAsTextLine, pipeDispatchLogEventToConsole]),
// Send to remote event sink
createPipe([pipeBlockLocalhost, pipeFilterSkipJournal, pipeFilterByLogLevel(LogLevel.TRACE), pipeBufferDebounce({
  debounceTime: getInt(PROP_KEY_SINK_DEBOUNCE_TIME) || DEFAULT_SINK_DEBOUNCE_TIME,
  maxBufferCount: getInt(PROP_KEY_SINK_MAX_BUFFER_SIZE) || DEFAULT_SINK_MAX_BUFFER_SIZE
}), pipeFormatBatchForSink, pipeDispatchLogEventToSink, pipeDispatchSentryLogEvent])])]));
const logForLevel = logLevel => dataString => logStream({
  logLevel,
  dataString
});
export const [trace, debug, info, warn, error] = [LogLevel.TRACE, LogLevel.DEBUG, LogLevel.INFO, LogLevel.WARN, LogLevel.ERROR].map(logForLevel);

/**
 * @deprecated Use `logService` instead.
 */
export const log = Object.assign(logStream, {
  [LogLevel.TRACE]: trace,
  [LogLevel.DEBUG]: debug,
  [LogLevel.INFO]: info,
  [LogLevel.WARN]: warn,
  [LogLevel.ERROR]: error
});
export const logService = {
  [LogLevel.TRACE]: trace,
  [LogLevel.DEBUG]: debug,
  [LogLevel.INFO]: info,
  [LogLevel.WARN]: warn,
  [LogLevel.ERROR]: error
};
//# sourceMappingURL=index.js.map